import { render, staticRenderFns } from "./ShowMaClass.vue?vue&type=template&id=adc93434&scoped=true"
import script from "./ShowMaClass.vue?vue&type=script&lang=js"
export * from "./ShowMaClass.vue?vue&type=script&lang=js"
import style0 from "./ShowMaClass.vue?vue&type=style&index=0&id=adc93434&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc93434",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('adc93434')) {
      api.createRecord('adc93434', component.options)
    } else {
      api.reload('adc93434', component.options)
    }
    module.hot.accept("./ShowMaClass.vue?vue&type=template&id=adc93434&scoped=true", function () {
      api.rerender('adc93434', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/MaClassDialog/ShowMaClass.vue"
export default component.exports